import ImageLightbox from "./ImageLightbox";
import VideoLightbox from "./VideoLightbox";
import type { PreviewItem } from "../../hooks/useMediaLightbox";

type MediaLightboxProps = {
  imagePreview: PreviewItem | null;
  imagePreviewList: PreviewItem[];
  imagePreviewIndex: number;
  imagePreviewVisible: boolean;
  onClose: () => void;
  onSelectIndex: (idx: number) => void;
  onSelectPreview: (item: PreviewItem | null) => void;
  videoPreview: PreviewItem | null;
  videoPreviewVisible: boolean;
  onCloseVideo: () => void;
};

function MediaLightbox({
  imagePreview,
  imagePreviewList,
  imagePreviewIndex,
  imagePreviewVisible,
  onClose,
  onSelectIndex,
  onSelectPreview,
  videoPreview,
  videoPreviewVisible,
  onCloseVideo,
}: MediaLightboxProps) {
  if (!imagePreview && !videoPreview) return null;
  return (
    <>
      {imagePreview && (
        <ImageLightbox
          imagePreview={imagePreview}
          imagePreviewList={imagePreviewList}
          imagePreviewIndex={imagePreviewIndex}
          imagePreviewVisible={imagePreviewVisible}
          onClose={onClose}
          onSelectIndex={onSelectIndex}
          onSelectPreview={onSelectPreview}
        />
      )}
      {videoPreview && (
        <VideoLightbox
          videoPreview={videoPreview}
          videoPreviewVisible={videoPreviewVisible}
          onClose={onCloseVideo}
        />
      )}
    </>
  );
}

export default MediaLightbox;
